// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datasets-tab-container{
    .custom-menu-icon{
        width: 35px;
        height: 28px;
        padding: 0px;
        margin-right: 4px;
        font-size: 55px;
    }
    .dataset-header-continer{
        margin-top: 10px;
        place-self: center;
        .download-button{
            width: 210px;
        }
    }

}
.models-tab-container{
    .custom-menu-icon{
        padding: 0px;
        margin-right: 4px;
        font-size: 55px;
        width: 41px;
        height: 27px;
    }
    .model-header-continer{
        margin-top: 10px;
        place-self: center;
        .download-button{
            width: 210px;
        }
    }
    .model-details-container {
        height: calc(100vh - 73px);
        overflow-y: auto;
    }
    .graphs-view-container{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .graph-container{
            width: 50%;
        }
        .graph-card{
            padding:0px !important;
            padding-top: 10px !important;
        }
        .graph-header{
            text-align: center;
        }
    }
    .models-metrics-card{
        padding: 9px !important;
        margin: 0px;
        .MuiCardContent-root{
            padding: 0px !important;
            margin: 0px;
        }
        
    }
    
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/datasets_models.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB;YACI,YAAY;QAChB;IACJ;;AAEJ;AACA;IACI;QAGI,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,WAAW;QACX,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB;YACI,YAAY;QAChB;IACJ;IACA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,gBAAgB;QAChB;YACI,UAAU;QACd;QACA;YACI,sBAAsB;YACtB,4BAA4B;QAChC;QACA;YACI,kBAAkB;QACtB;IACJ;IACA;QACI,uBAAuB;QACvB,WAAW;QACX;YACI,uBAAuB;YACvB,WAAW;QACf;;IAEJ;;AAEJ","sourcesContent":[".datasets-tab-container{\n    .custom-menu-icon{\n        width: 35px;\n        height: 28px;\n        padding: 0px;\n        margin-right: 4px;\n        font-size: 55px;\n    }\n    .dataset-header-continer{\n        margin-top: 10px;\n        place-self: center;\n        .download-button{\n            width: 210px;\n        }\n    }\n\n}\n.models-tab-container{\n    .custom-menu-icon{\n        width: 35px;\n        height: 28px;\n        padding: 0px;\n        margin-right: 4px;\n        font-size: 55px;\n        width: 41px;\n        height: 27px;\n    }\n    .model-header-continer{\n        margin-top: 10px;\n        place-self: center;\n        .download-button{\n            width: 210px;\n        }\n    }\n    .model-details-container {\n        height: calc(100vh - 73px);\n        overflow-y: auto;\n    }\n    .graphs-view-container{\n        display: flex;\n        justify-content: space-between;\n        margin-top: 10px;\n        .graph-container{\n            width: 50%;\n        }\n        .graph-card{\n            padding:0px !important;\n            padding-top: 10px !important;\n        }\n        .graph-header{\n            text-align: center;\n        }\n    }\n    .models-metrics-card{\n        padding: 9px !important;\n        margin: 0px;\n        .MuiCardContent-root{\n            padding: 0px !important;\n            margin: 0px;\n        }\n        \n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
